import addComponentLoader, { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const componentMapping =  {
  eventRsvp: defineAsyncComponent(() => importWithRetry(() => import('./root')))
}

addComponentLoader(componentMapping, {}, () => importWithRetry(() => import('./store')))
